import { proxy } from 'valtio/vanilla'
import { getSharedState } from '../valtio'

// Framework-agnostic mirror of the header's presence slice from useReviewSidebar
// (usersViewing + settings.unbiasedGrading). useReviewSidebar stays the source
// of truth — it owns the centrifuge websocket subscription — and pushes the
// slice here on change. Same bridge pattern as ticket-content / time-tracking.
//
// usersViewing is a Map<string, PresenceUser> in the Vue state; we mirror it as
// an array (id folded in) so the shape is plain data valtio can deep-track
// (getSharedState rejects non-plain values like Map/Set/Date at creation time).
export interface PresenceUser {
  id: string
  name: string
  avatar: string | null
  email?: string
  isReviewing: boolean
}

export interface TicketPresenceState {
  usersViewing: PresenceUser[]
  unbiasedGrading: boolean
}

export const ticketPresenceState = getSharedState('ticket-presence', () =>
  proxy<TicketPresenceState>({
    usersViewing: [],
    unbiasedGrading: false,
  }),
)
